import { render, staticRenderFns } from "./GridPromotedBuyboxRedesignExp.vue?vue&type=template&id=58148f96&scoped=true"
import script from "./GridPromotedBuyboxRedesignExp.vue?vue&type=script&setup=true&lang=ts"
export * from "./GridPromotedBuyboxRedesignExp.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./GridPromotedBuyboxRedesignExp.vue?vue&type=style&index=0&id=58148f96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58148f96",
  null
  
)

export default component.exports